/**
 * 命理术语白话释义库
 * 供 TermTip 点按弹卡使用。措辞中性克制，只作科普，不夸大吉凶。
 *
 * 每条：{ def: 一句白话定义, tone: '吉'|'凶'|'参半'|'中' }
 * tone 仅用于弹卡里的倾向小标，不代表断语。
 */

// 十神（含日主/日元）
const SHISHEN = {
  '日元': { def: '命主自身，代表你本人，是全盘论命的基准点。', tone: '中' },
  '日主': { def: '命主自身，代表你本人，是全盘论命的基准点。', tone: '中' },
  '比肩': { def: '与日主同类同阴阳，象征同辈、朋友与自立自强，也主竞争。', tone: '中' },
  '劫财': { def: '与日主同类异阴阳，主合作与分夺，钱财易聚易散。', tone: '中' },
  '食神': { def: '日主所生、同阴阳，主才艺、口福与温和的表达。', tone: '中' },
  '伤官': { def: '日主所生、异阴阳，主才华外露、聪明锋芒，不拘常规。', tone: '中' },
  '偏财': { def: '日主所克、同阴阳，主流动之财、机遇与人缘。', tone: '中' },
  '正财': { def: '日主所克、异阴阳，主稳定收入、务实与责任。', tone: '中' },
  '七杀': { def: '克日主、同阴阳，主压力、魄力与开创力，宜有制化。', tone: '中' },
  '正官': { def: '克日主、异阴阳，主名分、事业、约束与自律。', tone: '中' },
  '偏印': { def: '生日主、同阴阳，主偏门学识与直觉，又称枭神。', tone: '中' },
  '正印': { def: '生日主、异阴阳，主庇护、学业、名誉与长辈缘。', tone: '中' }
};

// 十二长生（能量强弱的十二种意象状态）
const CHANGSHENG = {
  '长生': { def: '如草木初生，力量渐起，主生机、起步与希望。', tone: '中' },
  '沐浴': { def: '又称败地，如初生受浴，主变动、洗练与尚未稳定。', tone: '中' },
  '冠带': { def: '如成年着冠束带，主渐入正轨、蓄势待发。', tone: '中' },
  '临官': { def: '又称建禄，力量壮盛，主自立、担当与本分之力。', tone: '中' },
  '帝旺': { def: '力量至于极盛，主鼎盛与巅峰，过刚亦需留意。', tone: '中' },
  '衰': { def: '盛极而转衰，主收敛、守成与由盛转平。', tone: '中' },
  '病': { def: '力量渐弱如患病，主消退、调养与谨慎行事。', tone: '中' },
  '死': { def: '气息将尽，主静止、沉潜与阶段性转折。', tone: '中' },
  '墓': { def: '又称库，主收藏、内敛与积蓄，不宜张扬。', tone: '中' },
  '绝': { def: '气尽而绝，主断续与变化中的低点，也孕育新机。', tone: '中' },
  '胎': { def: '如受孕成胎，主孕育、酝酿与新机初萌。', tone: '中' },
  '养': { def: '如养育待发，主休养、积累与待时而动。', tone: '中' }
};

// 神煞（覆盖 shensha-calculator.js 实际输出 + 常见名目 + 分类表所列）
const SHENSHA = {
  // —— 贵人 / 福禄 / 文昌（吉）——
  '天乙贵人': { def: '最尊贵的贵人星，主逢凶化吉、易得他人扶助。', tone: '吉' },
  '太极贵人': { def: '主好学深思，多与文史、玄学有缘。', tone: '吉' },
  '国印贵人': { def: '主权印与信誉，利承担责任、掌管事务。', tone: '吉' },
  '天官贵人': { def: '利名分与官运，多助职位、体面之事。', tone: '吉' },
  '天福贵人': { def: '主福气与顺遂，遇事多有转圜。', tone: '吉' },
  '天德贵人': { def: '主德泽庇佑，有化解灾厄、遇难成祥之意。', tone: '吉' },
  '月德贵人': { def: '主慈善福德，性情温厚，生活多平顺。', tone: '吉' },
  '福星贵人': { def: '主福气财禄，生活相对安逸顺心。', tone: '吉' },
  '禄神': { def: '日主的禄位所在，主衣食、俸禄与本分之财。', tone: '吉' },
  '天财': { def: '主财富机缘，利求财进益。', tone: '吉' },
  '财神': { def: '主财富机缘，利求财进益。', tone: '吉' },
  '文昌贵人': { def: '主聪慧文思，利读书、考试与学业功名。', tone: '吉' },
  '学堂': { def: '文星之一，主读书聪颖、利于进学。', tone: '吉' },
  '词馆': { def: '文星之一，主文采词章、笔下生辉。', tone: '吉' },
  '天书': { def: '文星之一，主慧根与文墨之缘。', tone: '吉' },
  '魁星': { def: '主文魁功名，利科举、考评脱颖。', tone: '吉' },
  '天赦': { def: '主赦免宽解，逢难多能得释。', tone: '吉' },
  // —— 武勇（吉，略带波折）——
  '将星': { def: '主统御与领导才能，能担当大任、掌实权。', tone: '吉' },
  '威权': { def: '主威望权势，气魄不凡。', tone: '吉' },
  '三台': { def: '主地位与声望，利居高位。', tone: '吉' },
  '飞廉': { def: '性烈之武星，主冲劲，亦须防口舌是非。', tone: '参半' },
  '伏兵': { def: '主暗中蓄势，行事宜谨慎低调。', tone: '参半' },
  // —— 婚喜（吉/参半）——
  '红鸾': { def: '主婚恋喜庆、姻缘之喜。', tone: '吉' },
  '天喜': { def: '主喜事、人缘与添丁之喜。', tone: '吉' },
  '金舆': { def: '主富贵安逸，多利配偶与出行车马。', tone: '吉' },
  '桃花': { def: '又名咸池，主异性缘与魅力，过旺则易生情困。', tone: '参半' },
  '咸池': { def: '即桃花，主情缘魅力与风情，宜守分寸。', tone: '参半' },
  // —— 天象 / 变动（参半）——
  '驿马': { def: '主奔波迁移、出行与变动，动中求机。', tone: '参半' },
  '华盖': { def: '主孤高清逸，与艺术、宗教、玄思有缘，略带孤独。', tone: '参半' },
  '金神': { def: '性刚烈果决，喜火来制，制化得宜方显其贵。', tone: '参半' },
  '天狗': { def: '主惊扰、口舌之类的小波折，宜防外伤。', tone: '凶' },
  '白虎': { def: '主血光、争斗之类的意外，宜谨慎。', tone: '凶' },
  '天哭': { def: '主忧思哀伤、情绪低落之意。', tone: '凶' },
  '地劫': { def: '主耗损，计划易生变数，宜留余地。', tone: '凶' },
  // —— 凶煞 / 刑害（凶）——
  '羊刃': { def: '刚锐之刃，主魄力冲劲，过旺易伤己伤人，宜有制。', tone: '凶' },
  '亡神': { def: '主内敛心机，易患得患失、思虑过多。', tone: '凶' },
  '劫煞': { def: '主破耗与意外之失，须防被劫夺、争夺。', tone: '凶' },
  '灾煞': { def: '主血光疾厄之类的波折，宜注意安全健康。', tone: '凶' },
  '天罗地网': { def: '主困顿束缚，行事易受牵绊、不畅。', tone: '凶' },
  '岁破': { def: '与太岁相冲，主冲动、破耗与变动之年。', tone: '凶' },
  '月破': { def: '与月令相冲，主根基不稳、易生反复。', tone: '凶' },
  '天刑': { def: '主刑克是非，须防官讼、争执。', tone: '凶' },
  '孤辰': { def: '主孤单、六亲缘分偏薄，多用于论男命。', tone: '参半' },
  '寡宿': { def: '主孤处独立、缘分偏冷，多用于论女命。', tone: '参半' }
};

// 其它（空亡 / 纳音）
const OTHER = {
  '空亡': { def: '该柱地支落于旬空，力量虚耗如空：吉星减吉、凶星减凶，主变数。', tone: '参半' },
  '纳音': { def: '六十甲子配五行的古法，用「炉中火、大海水」等意象补充干支五行的质感。', tone: '中' }
};

const GLOSSARY = { ...SHISHEN, ...CHANGSHENG, ...SHENSHA, ...OTHER };

/**
 * 取术语释义。找不到返回 null（调用方据此决定是否可点）。
 * 纳音支持前缀匹配：传「炉中火」→ 命中「纳音」通用条。
 */
export const getTerm = (name) => {
  if (!name) return null;
  if (GLOSSARY[name]) return { name, ...GLOSSARY[name] };
  return null;
};

/** 纳音专用：任意纳音名（如「炉中火」）都返回通用「纳音」释义 */
export const getNaYinTerm = () => ({ name: '纳音', ...OTHER['纳音'] });

export const toneColorVar = (tone) => {
  switch (tone) {
    case '吉': return 'var(--success)';
    case '凶': return 'var(--danger)';
    case '参半': return 'var(--accent-azure)';
    default: return 'var(--text-secondary)';
  }
};

export default GLOSSARY;
